import { Link } from "react-router-dom";
import { JobDetail } from "@/components/JobDetail";
import { TrustBadge } from "@/components/shared";
import { Loader2, PencilRuler } from "lucide-react";

// Renders only the role itself — no app chrome. The parent refreshes `job` after each AI turn.
export function JobPreview({ job }) {
  if (job === false) return <p className="p-8 text-sm text-rose-500" data-testid="ai-job-preview-error">This role could not be loaded. It may have been deleted.</p>;
  if (!job) return <p className="p-8 flex items-center gap-2 text-sm text-muted-foreground" data-testid="ai-job-preview-loading"><Loader2 className="h-4 w-4 motion-safe:animate-spin text-primary" />Loading the role…</p>;
  const empty = !job.summary && !(job.responsibilities || []).length;
  return (
    <div className="flex-1 min-h-0 overflow-y-auto" data-testid="ai-job-preview">
      <div className="max-w-3xl mx-auto p-5 lg:px-8 lg:py-6 space-y-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          {job.status === "published" ? <TrustBadge type="high">Live</TrustBadge> : <TrustBadge type="medium">Draft</TrustBadge>}
          <Link to={`/recruiter/jobs/${job.id}/build`} data-testid="ai-job-open-builder"
            className="inline-flex items-center gap-1.5 h-8 px-3 rounded-lg border border-border text-xs hover:border-primary/50 hover:text-primary transition-colors">
            <PencilRuler className="h-3.5 w-3.5" />Edit in full builder
          </Link>
        </div>
        {empty ? <p className="text-sm text-muted-foreground" data-testid="ai-job-preview-drafting">Your role is being drafted. It appears here as soon as it's ready.</p> : <JobDetail job={job} variant="recruiter" />}
      </div>
    </div>
  );
}
